import React, { memo, useCallback, useContext, MouseEvent } from 'react'
import { HorizontalDotsMinor } from '@shopify/polaris-icons'
import { Button } from 'src/components/shared/Button'
import { SubcontractorRequestsTableContext } from './SubcontractorRequestsTable.context'
import { SubcontractorRequest } from 'src/interfaces/subcontractor'

interface Props {
  subcontractorRequest: SubcontractorRequest
}

const SubcontractorRequestsActionButtonComponent = ({ subcontractorRequest }: Props) => {
  const { openSubcontractorRequestItemAction } = useContext(SubcontractorRequestsTableContext)

  const handleClickAction = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation()
      openSubcontractorRequestItemAction(event, subcontractorRequest)
    },
    [subcontractorRequest],
  )

  return (
    <Button
      color="white"
      size="tiny"
      leftIcon={<HorizontalDotsMinor width={20} height={20} />}
      onClick={handleClickAction}
    />
  )
}

export const SubcontractorRequestsActionButton = memo(SubcontractorRequestsActionButtonComponent)
